export default "__VITE_ASSET__BPo1MDuF__"